import { Grid, CircularProgress, stepContentClasses } from "@mui/material";
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import API from "../../utils/API";
import PCard from "../../components/pos/PCard.jsx";
import PConfirm from "../../components/pos/PConfirm";
import { useTranslation } from "react-i18next";

export default function StockDateRecon(props) {
  const { t } = useTranslation();
  const translate = t;

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [strProgress, setStrProgress] = useState(0);
  const isMounted = React.useRef(true);

  useEffect(() => {
    checkForActiveJob();

    return () => {
      isMounted.current = false;
      console.log("Child unmounted");
    };
  }, []);

  async function checkForActiveJob() {
    let { data } = await API.get(
      "/api/v1/activeworkrequestByType/reconcile_cost_and_stock"
    );
    if (data.length > 0) {
      setLoading(true);
      monitor(data[0].id);
    }
  }

  async function monitor(id) {
    while (true) {
      console.log("isMounted.current", isMounted.current);
      if (!isMounted.current) {
        break;
      }
      try {
        let result = await API.get("/api/v1/workrequest/" + id);
        setProgress("( " + result.data.progress + " %)");
        setStrProgress(result.data.strProgress);
        if (result.data.status === "Failed") {
          props.setAlert({
            show: true,
            title: translate("Alert!"),
            message: translate("Reconcilation Failed, please contact support"),
          });
          break;
        } else if (result.data.status === "Completed") {
          props.setAlert({
            show: true,
            title: translate("Success!"),
            message: translate("Reconcilation successfully"),
          });
          break;
        }
      } catch (err) {}
      await sleep(5000);
    }
    setLoading(false);
  }

  async function startSync() {
    console.log("sync Started called");
    setLoading(true);
    try {
      let { data } = await API.post("/api/v1/workrequest", {
        actionType: "reconcile_cost_and_stock",
        playload: {},
      });

      monitor(data.id);
    } catch (err) {
      setLoading(false);
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
      console.log(err);
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function onYesNoClicked(context, value) {
    console.log(context, value);
    if (context.eventType === "reconcileStockAndCost" && value === "yes") {
      console.log("startMigration called 1");
      await startSync();
    }
    setConfirmOpen(false);

    // setBlockYearEnding(true);
  }

  // function showDetailedError(err) {}

  async function startMigration() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Sync Product Data with Branches"),
      message: translate(
        "All Data will be getting Synced with Branches Except price"
      ),
      type: "warning",
      eventType: "reconcileStockAndCost",
      open: true,
      yes: true,
      no: true,
    });
  }

  var biRef = {};
  const content = (
    <div>
      {loading && (
        <div>
          Progress {progress} - {strProgress}
        </div>
      )}
      {
        <Button onClick={startMigration} variant="contained" disabled={loading}>
          {loading && <CircularProgress size={20} />}
          Reconcile Stock and Cost
        </Button>
      }

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );

  const customTitle = "Reconcile Stock and Cost";

  return <PCard avatar="R" title={customTitle} content={content}></PCard>;
}
